import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { SharedRoModule } from '../shared-ro/shared-ro.module';
import { SearchComponent } from './globalsearch.component';
import { ApiService } from './globalsearch.component.service';
import { SearchServiceConfig } from './globalsearch.component_service.config';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  declarations: [SearchComponent],
  imports: [
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule.forRoot(),
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    SharedRoModule.forRoot(),
    TranslateModule.forChild({
     loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix: '.json?v=' + Date.now()}),
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      }
    })
  ],
  exports: [
    SearchComponent
  ],
  providers: [SearchServiceConfig, ApiService]
})
export class SearchModule { }
